import React, { useEffect, useState } from "react";
import { partnerApi } from "../services/api";

export default function PartnerDashboard() {
  const [stats, setStats] = useState(null);
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const [statsRes, meRes] = await Promise.all([partnerApi.stats(), partnerApi.me()]);
        setStats(statsRes.data);
        setProfile(meRes.partner);
      } catch (err) {
        setError(err.message || "Failed to load dashboard");
      }
    })();
  }, []);

  if (error) return <div className="admin-error">{error}</div>;
  if (!stats) return <div className="admin-loading">Loading dashboard…</div>;

  return (
    <div>
      <h2>Welcome, {profile?.name || "Partner"}</h2>
      <p className="admin-muted">
        Cars are assigned automatically based on your sub register coverage.
      </p>
      <div className="admin-stats">
        <div className="admin-stat-card">
          <span>Total assigned</span>
          <strong>{stats.total}</strong>
        </div>
        <div className="admin-stat-card">
          <span>Approved</span>
          <strong>{stats.approved}</strong>
        </div>
        <div className="admin-stat-card">
          <span>Awaiting review</span>
          <strong>{stats.awaiting}</strong>
        </div>
        <div className="admin-stat-card">
          <span>Rejected</span>
          <strong>{stats.rejected}</strong>
        </div>
      </div>
      <div className="admin-card" style={{ marginTop: 24 }}>
        <h3>Assigned sub registers</h3>
        <ul>
          {(stats.subRegisters || []).map((sub) => (
            <li key={sub._id || sub.id}>{sub.name}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
